import { Col } from 'react-bootstrap';
import FooterLogoSection from './components/FooterLogoSection';
import {
  FooterWrapper,
  StyledContainer,
  StyledDivider,
  StyledRow
} from './styled';
import {
  AiLinks,
  bachKhoaLinks,
  digitalRecoursesLinks,
  managementLinks,
  otherServicesLinks,
  teachingLinks
} from '../Topbar/constant';
import FooterLinkBlock from './components/FooterLinkBlock';
import FooterQRCodeSection from './components/FooterQRCodeSection';
import FooterBottom from './components/FooterBottom';

function NewFooter() {
  return (
    <FooterWrapper>
      <StyledContainer>
        <FooterLogoSection />
        <StyledDivider />

        <StyledRow className="ipx-8 md:ipx-36">
          <Col md={4} sm={12}>
            <FooterLinkBlock
              title="ỨNG DỤNG TRÍ TUỆ NHÂN TẠO (AI)"
              links={AiLinks}
            />
          </Col>
          <Col md={4} sm={12}>
            <FooterLinkBlock
              title="CHUYỂN ĐỔI SỐ TRONG DẠY, HỌC VÀ KIỂM TRA ĐÁNH GIÁ"
              links={teachingLinks}
            />
          </Col>
          <Col md={4} sm={12}>
            <FooterLinkBlock
              title="TÀI NGUYÊN SỐ"
              links={digitalRecoursesLinks}
            />
          </Col>
        </StyledRow>

        <StyledRow className="ipx-8 md:ipx-36">
          <Col md={4} sm={12}>
            <FooterLinkBlock title="DỊCH VỤ KHÁC" links={otherServicesLinks} />
          </Col>
          <Col md={4} sm={12}>
            <FooterLinkBlock
              title="CHUYỂN ĐỔI SỐ TRONG QUẢN LÝ, VẬN HÀNH"
              links={managementLinks}
            />
          </Col>
          <Col md={4} sm={12}>
            <FooterLinkBlock
              title="BACH KHOA TECH GROUP"
              links={bachKhoaLinks}
            />
            <FooterQRCodeSection
              appStoreUrl="https://apps.apple.com/vn/app/lms360/id6475024661?l=vi"
              playStoreUrl="https://play.google.com/store/apps/details?id=lms360.vn"
            />
          </Col>
        </StyledRow>
        <StyledDivider />
        <FooterBottom />
      </StyledContainer>
    </FooterWrapper>
  );
}

export default NewFooter;
